/* unplugin-vue-components disabled */import { render } from "./IntroQuickMessage.vue?vue&type=template&id=f4bef00e&scoped=true"
import script from "./IntroQuickMessage.vue?vue&type=script&lang=js"
export * from "./IntroQuickMessage.vue?vue&type=script&lang=js"

import "./IntroQuickMessage.vue?vue&type=style&index=0&id=f4bef00e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4bef00e"]])

export default __exports__